"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipTextField = void 0;
var React = __importStar(require("react"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var ChipInputComponent_1 = require("./ChipInputComponent");
exports.ChipTextField = React.forwardRef(function ChipTextField(_a, ref) {
    var _b = _a.InputProps, _c = _b === void 0 ? {} : _b, InputProps = __rest(_c, []), _d = _a.inputProps, _e = _d === void 0 ? {} : _d, inputProps = __rest(_e, []), _f = _a.InputLabelProps, _g = _f === void 0 ? {} : _f, InputLabelProps = __rest(_g, []), chips = _a.chips, props = __rest(_a, ["InputProps", "inputProps", "InputLabelProps", "chips"]);
    return (React.createElement(TextField_1.default, __assign({ InputProps: __assign({ inputComponent: ChipInputComponent_1.ChipInputComponent }, InputProps), inputProps: __assign({ chips: chips }, inputProps), InputLabelProps: __assign({ shrink: !!(Array.isArray(chips) ? chips.length : chips) || undefined }, InputLabelProps) }, props, { ref: ref })));
});
//# sourceMappingURL=ChipTextField.js.map